import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
    MatCardModule,
} from "@angular/material/card";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router, RouterLink} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {
    MatTableDataSource, MatTableModule
} from "@angular/material/table";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatMenuModule} from "@angular/material/menu";
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";

import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ResultService} from "../../../../services/result-service/result.service";
import {UserService} from "../../../../services/user-service/user.service";
import {AnalyseResult, AnalyseService} from "../../../../services/analyse-service/analyse.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ExploitationService} from "../../../../services/exploitation-service/exploitation.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {MatNativeDateModule} from "@angular/material/core";
import {AnalyseDTO} from "../../../_models/analyse.dtos";
import {ShortUserDTO} from "../../../_models/user.dtos";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {environment} from "../../../../../environments/environment";
import { finalize, Observable } from 'rxjs';
import { AuthService } from '../../../../services/user-service/AuthService';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-in-progress-analyses',
    providers: [ResultService, UserService, AnalyseService, ApiService, Endpoints, DialogService, HandleErrorsService, ExploitationService, ClientsService],
    standalone: true,
    imports: [FormsModule,
        MatDatepickerModule, MatNativeDateModule,
        DatePipe, MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, MatCheckbox, MatProgressSpinner, NgClass
    ],
    templateUrl: './calculated-analyses.component.html',
    styleUrl: './calculated-analyses.component.scss'
})
export class CalculatedAnalyse implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<AnalyseResult>;
    @ViewChild('viewModal') viewModal: TemplateRef<AnalyseResult>;
    @ViewChild('tableContainer', {static: false}) tableContainer!: ElementRef;

    searchValue: string = ''
    editForm: FormGroup;
    form: FormGroup;
    selectedAll: boolean = false
    selectedElements: Set<AnalyseResult> = new Set<AnalyseResult>()
    userList: ShortUserDTO[] = []
    analyse?: AnalyseResult
    dataSource = new MatTableDataSource<AnalyseResult>();
    displayedColumns: string[] = [
        'select',
        'ref',
        'sampleCode',
        'sampleAnalyseRef',
        'parameter',
        'startDate',
        'endDate',
        'lq',
        'poids',
        'resultatFinale',
        'afficherRapport',
        'commentaireResult',
        'action'];

    columnLabels: Record<string, string> = {
        select: 'Sélection',
        ref: 'Référence',
        sampleCode: 'Code échantillon',
        sampleAnalyseRef: 'Réf. analyse',
        parameter: 'Paramètre',
        startDate: 'Date début',
        endDate: 'Date fin',
        lq: 'LQ',
        poids: 'Poids',
        resultatFinale: 'Résultat final',
        afficherRapport: 'Afficher rapport',
        commentaireResult: 'Commentaire',
        action: 'Action',
        };
    loadingTable: boolean = false;
    loadingCalBtn: boolean = false;
    loadingValBtn: boolean = false;
    editedItems: Set<AnalyseResult> = new Set<AnalyseResult>()
    @ViewChild('validationModal') validationModal!: TemplateRef<any>;
    @ViewChild('revisionModal') revisionModal!: TemplateRef<any>;

  calculableSamples: any[] = [];
  selectAll = false;
    constructor(
        private analyseService: AnalyseService,
        private cookieService: CookieService,
        private userService: UserService,
        private router:Router,
        private handleErrors: HandleErrorsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private authService: AuthService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
        this.initializeCreateForm()
    }
currentUserRole: string = ''; // rôle de l'utilisateur connecté

    ngOnInit(): void {
        this.loadingTable = true;
        this.fetchAnalyseList()
        // 🔹 Méthode 1 : récupérer depuis le BehaviorSubject (recommandé)
        this.authService.user$.subscribe(user => {
            if (user) {
                this.currentUserRole = user.role; // ex: 'ROLE_SAMPLERS' ou 'ROLE_RESPONSABLE_QUALITE'
                console.log('Rôle actuel de l’utilisateur :', this.currentUserRole);
            }
        });

        // Méthode 2 : depuis sessionStorage
        const storedRole = sessionStorage.getItem('user_roles');
        if (storedRole) {
            // 🔹 Garde ROLE_ pour correspondre au HTML
            this.currentUserRole = storedRole.split(' ').find(r => r === 'ROLE_SAMPLERS' || r === 'ROLE_RESPONSABLE_LABORATOIRE') || '';
            console.log('Rôle actuel récupéré depuis sessionStorage :', this.currentUserRole);
        }
    }

revisableSamples: any[] = [];
selectAllRevision: boolean = false;


openValidationModal(modalTemplate: TemplateRef<any>) {
  this.loadingCalBtn = true;
  console.log('--- Début de openValidationModal ---');

  this.analyseService.getAnalyseResultsByStatut('CALCULE').subscribe({
    next: (results: any[]) => {
      console.log('Résultats bruts reçus du service :', results);

      if (!Array.isArray(results)) {
        console.error('Résultats reçus ne sont pas un tableau !', results);
        this.loadingCalBtn = false;
        return;
      }

      // 🔹 Grouper les samples par sampleId
      const groupedSamplesMap = new Map<number, any>();
      results.forEach((res, index) => {
        const sampleId = res.sampleId;
        if (!sampleId) return;

        const sampleCode = res.sampleCode || 'N/A';
        const clientName = res.clientName || 'N/A';
        const referenceInterne = res.sampleAnalyseRef ||  'N/A';
        const dateAnalyse = res.dateMesure || res.startDate || null;

        if (!groupedSamplesMap.has(sampleId)) {
          groupedSamplesMap.set(sampleId, {
            id: sampleId,
            code: sampleCode,
            clientName: clientName,
            referenceInterne : referenceInterne,
            statut: 'CALCULE',
            dateAnalyse: dateAnalyse,
            selected: false,
            resultsCount: 1,
            results: [res]
          });
        } else {
          const sample = groupedSamplesMap.get(sampleId);
          sample.results.push(res);
          sample.resultsCount++;
        }
      });

      // 🔹 On récupère le rôle mais on n'a plus besoin de vérifier validatedByTechnicien
      const roles: string[] = sessionStorage.getItem('user_roles')?.split(' ') || [];
      console.log('👤 Rôles utilisateur :', roles);

      const currentRole = roles.includes('ROLE_RESPONSABLE_LABORATOIRE') ? 'ROLE_RESPONSABLE_LABORATOIRE' : '';
      console.log('Rôle sélectionné pour le modal :', currentRole);

      // 🔹 Filtrer les samples : maintenant on affiche simplement tous les résultats CALCULE
      this.calculableSamples = Array.from(groupedSamplesMap.values());

      console.log('\n✅ Samples filtrés pour le modal :', this.calculableSamples);
      console.log('Nombre total de samples affichés :', this.calculableSamples.length);

      // ⚡ Forcer Angular à détecter les changements avant d'ouvrir le modal
      this.cdr.detectChanges();

      this.loadingCalBtn = false;
      this.modalService.open(modalTemplate, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
      console.log('Modal ouvert !');
    },
    error: (err) => {
      console.error('Erreur chargement des résultats calculés', err);
      this.loadingCalBtn = false;
    }
  });
}
openRevisionModal(modalTemplate: TemplateRef<any>) {
  this.loadingCalBtn = true;
  console.log('--- Début de openRevisionModal ---');

  // 🔹 Appel service pour récupérer les résultats calculés
  this.analyseService.getAnalyseResultsByStatut('CALCULE').subscribe({
    next: (results: any[]) => {
      console.log('Résultats bruts pour révision reçus :', results);

      if (!Array.isArray(results)) {
        console.error('Résultats reçus ne sont pas un tableau !', results);
        this.loadingCalBtn = false;
        return;
      }

      // 🔹 Grouper les samples par sampleId
      const groupedSamplesMap = new Map<number, any>();
      results.forEach((res, index) => {
        console.log(`Traitement du résultat index ${index} :`, res);

        const sampleId = res.sampleId;
        if (!sampleId) {
          console.warn('Impossible de trouver sampleId pour ce résultat :', res);
          return;
        }

        const sampleCode = res.sampleCode || 'N/A';
        const clientName = res.clientName || 'N/A';
        const referenceInterne = res.sampleAnalyseRef || 'N/A';
        const dateAnalyse = res.dateMesure || res.startDate || null;

        if (!groupedSamplesMap.has(sampleId)) {
          groupedSamplesMap.set(sampleId, {
            id: sampleId,
            code: sampleCode,
            referenceInterne : referenceInterne,
            clientName: clientName,
            statut: 'CALCULE',
            dateAnalyse: dateAnalyse,
            selected: false,
            resultsCount: 1,
            results: [res]
          });
        } else {
          const sample = groupedSamplesMap.get(sampleId);
          sample.results.push(res);
          sample.resultsCount++;
        }
      });

      // 🔹 Récupérer les rôles utilisateur
      const roles: string[] = sessionStorage.getItem('user_roles')?.split(' ') || [];
      console.log('👤 Rôles utilisateur :', roles);

      // 🔹 Vérifier que c’est bien un responsable qualité
      if (!roles.includes('ROLE_RESPONSABLE_LABORATOIRE')) {
        console.warn('🔒 Seul le responsable de laboratoire peut réviser.');
        this.loadingCalBtn = false;
        return;
      }

      // 🔹 Filtrer les samples → directement tous les résultats calculés (plus besoin de validé par technicien)
      this.revisableSamples = Array.from(groupedSamplesMap.values());

      console.log('✅ Samples filtrés pour révision :', this.revisableSamples);

      // ⚡ Détecter les changements et ouvrir le modal
      this.cdr.detectChanges();
      this.loadingCalBtn = false;
      this.modalService.open(modalTemplate, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
      console.log('Modal de révision ouvert !');
    },
    error: (err) => {
      console.error('Erreur chargement des résultats à réviser', err);
      this.loadingCalBtn = false;
    }
  });
}

onAfficherRapportChange(element: any): void {
    console.log('🔄 Toggle rapport pour:', element.parameterName, '→', element.afficherDansRapport);
    
    this.analyseService.updateAfficherRapport(element.id, element.afficherDansRapport)
        .subscribe({
            next: (res) => console.log('✅ Sauvegardé:', res),
            error: (err) => {
                // ✅ Voir l'erreur exacte
                console.error('❌ Erreur complète:', err);
                console.error('❌ Status:', err.status);
                console.error('❌ Message:', err.error);
                console.error('❌ URL appelée:', err.url);
                element.afficherDansRapport = !element.afficherDansRapport;
            }
        });
}
    onValidate(modal: any): void {
    console.log('🟢 Bouton VALIDER cliqué');

    const selectedSamples = this.calculableSamples.filter(s => s.selected);

    if (selectedSamples.length === 0) {
        console.warn('⚠️ Aucun sample sélectionné');
        return;
    }

    const canValidateAsTechnicien =
        this.hasRole('ROLE_SAMPLERS');

    const canValidateAsQuality =
        this.hasRole('ROLE_RESPONSABLE_LABORATOIRE');

    const isAdmin = this.hasRole('ROLE_ADMIN');

    console.log('🔑 Rôles:', {
        technicien: canValidateAsTechnicien,
        quality: canValidateAsQuality,
        admin: isAdmin
    });

    // 🔹 samples تحتاج validation technicien
    const needsTechnicienValidation = selectedSamples.some(sample =>
        sample.results.some((r: { validatedByTechnicien: any; }) => !r.validatedByTechnicien)
    );

    // 🔹 samples تحتاج validation qualité
    const needsQualityValidation = selectedSamples.some(sample =>
        sample.results.every((r: { validatedByTechnicien: any; }) => r.validatedByTechnicien) &&
        sample.results.some((r: { validatedByQuality: any; }) => !r.validatedByQuality)
    );

    console.log('➡ needsTechnicienValidation:', needsTechnicienValidation);
    console.log('➡ needsQualityValidation:', needsQualityValidation);

    // ✅ TECHNICIEN
    if ((canValidateAsTechnicien || isAdmin) && needsTechnicienValidation) {
        console.log('🛠 Validation Technicien');
        this.validateSelectedSamplesByTechnicien(modal);
        return;
    }

    // ✅ RESPONSABLE QUALITÉ
    if ((canValidateAsQuality || isAdmin) && needsQualityValidation) {
        console.log('✅ Validation Responsable Laboraoire');
        this.validateSelectedSamplesByRespQualite(modal);
        return;
    }

    console.warn('⚠️ Aucun type de validation applicable');
    }

    toggleAll() {
        this.calculableSamples.forEach(s => s.selected = this.selectAll);
    }

    hasSelectedSamples(): boolean {
        return this.calculableSamples.some(s => s.selected);
    }

    validateSelectedSamples1() {
    const selectedSamples = this.calculableSamples.filter(s => s.selected);
    if (!selectedSamples.length) return;

    const sampleIds = selectedSamples.map(s => s.id);
    console.log('IDs des samples sélectionnés :', sampleIds);

    this.analyseService.validateMultipleResult(sampleIds).subscribe({
        next: (response) => {
        console.log('Réponse backend :', response);
        this.fetchAnalyseList();
        console.log('Samples mis à jour localement :', selectedSamples);
        },
        error: (err) => console.error('Erreur lors de la validation :', err)
    });
    }

validateSelectedSamplesByTechnicien(modal?: any) {
    this.validateSamples('technicien', modal);
  }

  // 🔹 Méthode de validation pour le Responsable Qualité
  validateSelectedSamplesByRespQualite(modal?: any) {
    this.validateSamples('respQualite', modal);
  }

  // 🔹 Méthode interne partagée
    private validateSamples(role: 'technicien' | 'respQualite', modal?: any) {
        console.log('--- Début de validateSamples ---');
        console.log('Rôle utilisé pour validation :', role);

        // 🔹 Filtrer les samples sélectionnés
        const selectedSamples = this.calculableSamples.filter(s => s.selected);
        console.log('Samples sélectionnés :', selectedSamples);

        if (!selectedSamples.length) {
            console.warn('Aucun sample sélectionné pour validation');
            return;
        }

        // 🔹 Récupérer les IDs
        const sampleIds = selectedSamples.map(s => s.id);
        console.log(`📦 IDs des samples sélectionnés pour validation ${role} :`, sampleIds);

        this.loadingCalBtn = true;

        // 🔹 Choisir le service selon le rôle
        let serviceCall: Observable<any>;
        if (role === 'technicien') {
            console.log('Appel du service validateResultsByTechnicien');
            serviceCall = this.analyseService.validateResultsByTechnicien(sampleIds);
        } else if (role === 'respQualite') {
            console.log('Appel du service validateMultipleResult');
            serviceCall = this.analyseService.validateMultipleResult(sampleIds);
        } else {
            console.error('Rôle inconnu pour validation !');
            this.loadingCalBtn = false;
            return;
        }

        // 🔹 Appel du service et attendre la réponse
        serviceCall.subscribe({
            next: (response) => {
                console.log(`✅ Réponse backend ${role} :`, response);

                if (response?.status) {
                    console.log(`✔ Validation réussie pour le rôle ${role}`);

                    // 🔹 Mettre à jour la liste après la validation réussie
                    this.fetchAnalyseList();

                    // 🔹 Fermer le modal si présent
                    if (modal) {
                        console.log('Fermeture du modal après validation');
                        modal.close();
                    }

                    // 🔹 Marquer localement les samples comme validés (optionnel)
                    if (role === 'technicien') {
                        selectedSamples.forEach(s => s.validatedByTechnicien = true);
                    } else if (role === 'respQualite') {
                        selectedSamples.forEach(s => s.validatedByQuality = true);
                    }
                    this.dialogService.openSuccessDialog(
                    `Les échantillons ont été validés avec succès par ${role === 'technicien' ? 'le technicien' : 'le responsable de laboratoire'}.`
                );
                } else {
                    console.warn(`❌ Validation ${role} échouée :`, response?.message || 'Pas de message du backend');
                    this.dialogService.openDangerAlert(
                    response?.message || 'La validation a échoué côté serveur.'
                );
                }

                this.loadingCalBtn = false;
            },
            error: (err) => {
                console.error(`❌ Erreur lors de la validation ${role} :`, err);
                this.loadingCalBtn = false;
            }
        });

        console.log('--- Fin de validateSamples ---');
    }
tempValues: { [id: number]: any } = {};

saveManualResult(element: any, value: any): void {
  console.log('🔵 saveManualResult called');
  console.log('  element.id =', element.id);
  console.log('  value reçu =', value, '| type =', typeof value);

  const parsed = parseFloat(value);
  console.log('  parsed =', parsed, '| isNaN =', isNaN(parsed));

  if (value === null || value === undefined || value === '' || isNaN(parsed)) {
    console.warn('⚠️ Valeur invalide → abandon');
    this.dialogService.openDangerAlert('Veuillez saisir une valeur valide');
    return;
  }

  console.log('📤 Appel API updateResultatFinale | id=', element.id, '| parsed=', parsed);

  this.analyseService.updateResultatFinale(element.id, parsed).subscribe({
    next: (response) => {
      console.log('✅ API success | response =', response);
      element.resultatFinale = parsed;
      console.log('  element.resultatFinale mis à jour =', element.resultatFinale);
      delete this.tempValues[element.id];
      this.fetchAnalyseList()
      this.cdr.detectChanges();
      console.log('  tempValues après suppression =', this.tempValues);
      this.dialogService.openSuccessDialog('Résultat enregistré avec succès');
    },
    error: (err) => {
      console.error('❌ API error | status =', err.status);
      console.error('  message =', err.message);
      console.error('  error body =', err.error);
      console.error('  url =', err.url);
      this.dialogService.openDangerAlert('Erreur lors de l\'enregistrement');
    }
  });
}
    fetchAnalyseList(): void {
    console.log("🚀 fetchAnalyseList called");
    this.loadingTable = true;

    this.analyseService.getAnalyseResultsByStatut('CALCULE')
        .pipe(
        finalize(() => {
            this.loadingTable = false;
            console.log("⏹ Loading terminé");
        })
        )
        .subscribe({
        next: (data) => {
            console.log('📥 Données reçues (CALCULE) :', data);
            // ✅ Initialiser afficherDansRapport si absent
            this.dataSource.data = (data ?? []).map((r: any) => ({
                ...r,
                afficherDansRapport: r.afficherDansRapport ?? false
            }));
        },
        error: (err) => {
            console.error('❌ Erreur chargement EN_COURS :', err);
        }
        });
}

    /*fetchAnalyseList1() {
        this.analyseService.findAllCalculatedAnalyses().subscribe(
            {
                next: response => {
                    if (response.status) {
                        this.dataSource.data = response.data
                        this.fetchUsers()
                    }
                    this.loadingTable = true;
                },
                error: err => {
                    this.handleErrors.catchError(err)
                    this.loadingTable = false;
                },
                complete: () => this.loadingTable = false
            }
        )
    }*/

    fetchUsers() {
        this.userService.getUsers().subscribe({
            next: res => {
                if (res.status) {
                    this.userList = res.data
                }
            }
        })
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            refAnalyse: ['', Validators.required],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            lq: ['', Validators.required],
            creationDate: ['', Validators.required],
            status: [null, Validators.required],
            commentaire: ['', Validators.required],
            sampleId: [null, Validators.required],
            sampleCode: ['', Validators.required],
            parameterId: [null, Validators.required],
            parameterName: ['',],
            userId: [null, Validators.required],
            resultId: [null, Validators.required],
            poids: ['', Validators.required],
            resultat: ['', Validators.required],
            resultatFinale: ['', Validators.required],
            userName: ['',],
        });

    }

    initializeCreateForm() {
        this.form = this.fb.group({
            userId: ['', Validators.required]
        });
    }

    openViewModel(element: AnalyseResult) {
        this.analyse = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    updateTableRow(analyseDTO: AnalyseResult) {
        const index = this.dataSource.data.findIndex(item => item.id === analyseDTO.id);
        if (index !== -1) {
            this.dataSource.data[index] = analyseDTO;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(id: number) {
        this.dialogService.open('Etes-vous sûr de vouloir supprimer cet élément ?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteAnalyse(id);
                }
            });
    }

    private deleteAnalyse(id: number) {
        this.analyseService.delete(id).subscribe({
            next: response => {
                if (response.status) {
                    this.dataSource.data = this.dataSource.data.filter(item => item.id != id)
                    this.dialogService.openSuceessAlert(response.message);

                } else {
                    this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();

                }
            }, error: err => this.handleErrors.catchError(err),
        })
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    updateAnalyse(element: AnalyseResult) {
        this.analyseService.updateE(element).subscribe({
            next: response => {
                if (response.status) {
                    this.updateTableRow(response.data)
                    this.modalService.dismissAll();
                    this.dialogService.openSuccessDialog(response.message);
                } else {
                    this.dialogService.openDangerDialog(response.message);
                }
            },
            error: err => this.handleErrors.catchError(err),
            complete: () => {
                this.initializePaginatorAndSort();
            }
        });
    }

    handleChecked(element: AnalyseResult) {
        if (this.selectedElements.has(element)) {
            this.selectedElements.delete(element)
        } else {
            this.selectedElements.add(element)
        }
    }

    handleSelectAll() {
        this.selectedAll = !this.selectedAll
        if (this.selectedAll)
            this.selectedElements = new Set<AnalyseResult>(this.dataSource.data)
        else
            this.selectedElements = new Set<AnalyseResult>()
    }// Vérifie si au moins un sample est sélectionné pour révision
hasSelectedRevisableSamples(): boolean {
  return this.revisableSamples?.some(s => s.selected);
}

toggleAllRevision() {
  if (!this.revisableSamples || this.revisableSamples.length === 0) {
    return;
  }

  console.log('🔘 Toggle all:', this.selectAllRevision);

  this.revisableSamples.forEach(sample => {
    sample.selected = this.selectAllRevision;
    console.log(`   → ${sample.code} selected = ${sample.selected}`);
  });
}
// 🔹 Action pour envoyer les samples à la révision
reviserSelectedSamples(modal: any) {
  // 🔹 Récupération des IDs sélectionnés
  const selectedIds = this.revisableSamples
    .filter(s => s.selected)
    .map(s => s.id);

  console.log('--- Début de la révision des samples ---');
  console.log('Samples sélectionnés pour révision :', selectedIds);

  if (selectedIds.length === 0) {
    console.warn('Aucun sample sélectionné, action annulée.');
    return;
  }

  this.loadingCalBtn = true;
  console.log('Appel du service reviseResults pour les samples...');

  this.analyseService.reviseResults(selectedIds).subscribe({
    next: (resp) => {
      console.log('✅ Réponse reçue du backend pour la révision :', resp);

      if (resp.success) {
        console.log(`🎉 ${selectedIds.length} sample(s) envoyés à la révision avec succès.`);
      } else {
        console.warn('⚠️ La révision a retourné un message :', resp.message);
      }

      // 🔹 Rafraîchir la liste principale après la révision
      console.log('Rafraîchissement de la liste principale des analyses...');
      this.fetchAnalyseList();

      // 🔹 Fermer le modal
      console.log('Fermeture du modal de révision.');
      modal.close();

      this.loadingCalBtn = false;
      console.log('--- Fin de la révision ---');
    },
    error: (err) => {
      console.error('❌ Erreur lors de l’envoi à la révision', err);
      this.loadingCalBtn = false;
    }
  });
}


    navigateInputs(event: KeyboardEvent, index: number, column: string): void {
        const columns = ['ref', 'sampleCode', 'parameter','sampleAnalyseRef', 'status', 'startDate', 'endDate','lq', 'poids', 'resultat', 'resultatFinale','afficherRapport', 'commentaire','commentaireResult']; // Add all columns with inputs here
        const columnIndex = columns.indexOf(column);

        switch (event.key) {
            case 'Enter':
            case 'ArrowDown':
                const nextRow = document.getElementById(`${column}${index + 1}`);
                if (nextRow) nextRow.focus();
                event.preventDefault();
                break;

            case 'ArrowUp':
                // Move to the input above, if it exists
                const previousRow = document.getElementById(`${column}${index - 1}`);
                if (previousRow) previousRow.focus();
                event.preventDefault();
                break;

            case 'ArrowRight':
                if (columnIndex < columns.length - 1) {
                    // Move to the next column in the same row
                    const nextColumn = document.getElementById(`${columns[columnIndex + 1]}${index}`);
                    if (nextColumn) nextColumn.focus();
                    event.preventDefault();
                }
                break;

            case 'ArrowLeft':
                if (columnIndex > 0) {
                    // Move to the previous column in the same row
                    const previousColumn = document.getElementById(`${columns[columnIndex - 1]}${index}`);
                    if (previousColumn) previousColumn.focus();
                    event.preventDefault();
                }
                break;
        }
    }

    recalculerMultipleResult() {
        console.log("Début de recalculerMultipleResult");
    
        if (this.selectedElements.size == 0) {
            console.log("Aucun élément sélectionné.");
            this.dialogService.openDangerDialog("Veuillez sélectionner au moins un élément.");
            return;
        }
    
        this.loadingCalBtn = true;
        console.log("selectedElements avant envoi :", this.selectedElements);
    
        const dtos: AnalyseResult[] = [...this.selectedElements];
        console.log("DTOS envoyés :", dtos);
    
        const updatedData = this.dataSource.data.filter(item => !this.selectedElements.has(item));
    
        this.analyseService.recalculerMultipleResult(dtos).subscribe({
            next: () => {
                console.log("Réinitialisation terminée.");
                this.dataSource.data = updatedData;    
                this.modalService.dismissAll();
                this.dialogService.openSuccessDialog("Les résultats ont été réinitialisés avec succès.");
            },
            error: err => {
                console.error("Erreur détectée :", err);
                this.handleErrors.catchError(err);
                this.editedItems = new Set<AnalyseResult>();
                this.loadingCalBtn = false;
                this.dialogService.openDangerDialog("Une erreur est survenue lors de la réinitialisation.");
            },
            complete: () => {
                console.log("Requête terminée.");
                this.editedItems = new Set<AnalyseResult>();
                this.loadingCalBtn = false;
            }
        });
    
        console.log("Fin de recalculerMultipleResult");
    }
     
    addResult(element: AnalyseResult) {
        this.editedItems.add(element)
        console.log(this.editedItems)
    }

    // Vérifie si le résultat finale dépasse la LQ
  isOverLQ(element: any): boolean {
  const over = element.resultatFinale > element.lq; // ou element.lqValue selon ton champ
  return over;
}
getUserRoles(): string[] {
  const roles = sessionStorage.getItem('user_roles');
  if (!roles) {
    return [];
  }

  const rolesArray = roles.split(' '); // تحويل string → array
  return rolesArray;
}

hasRole(role: string): boolean {
  const has = this.getUserRoles().includes(role);
  return has;
}

hasAnyRole(roles: string[]): boolean {
  const userRoles = this.getUserRoles();
  const hasAny = roles.some(r => userRoles.includes(r));
  return hasAny;
}

columns: string[] = [...this.displayedColumns];
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');
    private setColsCookie() {
        this.cookieService.set(`anaRCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

}

